import { z } from "zod";

import { jobBoardSchema } from "../../job-search.dto";

// Spec 047 — the v2 decision contract lives in libs/schema and is re-exported
// from the dto barrel; the legacy v1 response schema stays here so the
// published extension keeps its exact v1 wire shape.
export {
  type BlockedDecision,
  CLAIM_BLOCK_REASONS,
  type ClaimBlockReason,
  claimBlockReasonSchema,
  type ClaimDecision,
  claimDecisionSchema,
  type ClaimedDecision,
  type CompleteDecision,
} from "@reactive-resume/schema";

/**
 * Legacy v1 claim payload. Kept local because it narrows `board` to the
 * JobBoard enum (the shared `claimPayloadSchema` accepts any non-empty board
 * string so the extension can fail closed on unsupported boards itself).
 */
export const claimResponseSchema = z.object({
  applicationId: z.string(),
  board: jobBoardSchema,
  jobUrl: z.string().url(),
  coverLetter: z.string(),
  deterministicFillData: z.record(z.string(), z.unknown()),
  expectedProfileId: z.string().nullable(),
  expectedSubmissionMethod: z.literal("LINKEDIN_EASY_APPLY_EXTENSION"),
  claimExpiresAt: z.string().datetime(),
});

export type ClaimResponseDto = z.infer<typeof claimResponseSchema>;
